import compact from 'lodash/compact';

const allCategories = (category_id, sub_categories, categories) => {
  const categoryId = parseInt(category_id, 10);
  const allCategoryIds = compact(
    (sub_categories || []).slice(0).map(e => e.id).concat([categoryId])
  );
  return categories.filter(e => allCategoryIds.indexOf(e.id) > -1);
};

export default allCategories;



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/lib/categoriesMapper.js